// removed by extract-text-webpack-plugin
module.exports = {"miniProgress":"antd-pro-charts--mini-progress-miniProgress","progressWrap":"antd-pro-charts--mini-progress-progressWrap","progress":"antd-pro-charts--mini-progress-progress","target":"antd-pro-charts--mini-progress-target"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/Charts/MiniProgress/index.less
// module id = 922
// module chunks = 0